var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.670414 0.314909C0.942337 0.110994 1.27023 0.00075113 1.60709 0H13.3928C13.7224 0.000245516 14.0437 0.105334 14.3127 0.300776L7.94385 4.59824C7.81232 4.687 7.65842 4.73451 7.50092 4.73476C7.34356 4.73488 7.18941 4.68799 7.05766 4.5996L0.670414 0.314909ZM8.53225 5.51751C8.22637 5.724 7.86846 5.83436 7.50242 5.83499C7.13639 5.83548 6.77814 5.72634 6.47177 5.52071L0.0621795 1.22073C0.0228366 1.36043 0.0019102 1.50481 0 1.65016V9.35003C0.000478316 9.78744 0.169922 10.2069 0.471275 10.5162C0.772494 10.8255 1.18111 10.9995 1.60714 11H13.3929C13.8189 10.9995 14.2275 10.8255 14.5287 10.5162C14.8301 10.2069 14.9995 9.78741 15 9.35003V1.65016C14.9978 1.49732 14.9748 1.34546 14.9314 1.19911L8.53225 5.51751Z",
    fill: "#3C2166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.640141eac91c1fe5c792c3af060b84af.svg";
export { ForwardRef as ReactComponent };